import { connect } from "react-redux";
import FormTemplate from "./template";
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import Modal from "../../utils/customModal";
import TokenComponent from "../../shared/token";
import { withTranslation } from "react-i18next";
import * as instanceActions from "../../../Redux/api";
import { getAchBanks } from "../../../Redux/reducer/providers";
import {
  getSessionCountry,
  getSessionInfo,
} from "../../../Redux/reducer/session";
import FindInstitution from "../../private/provider/findInstitution";
import * as ClientActions from "../../../Redux/actions/clientActions";
import { getClient, getAccounts } from "../../../Redux/reducer/clients";
import * as ProviderActions from "../../../Redux/actions/providerActions";
import personProvider from "../../../../static/images/personProvider.svg";
import {
  loadingHtml,
  sucessInfoModal,
  errorContainer,
  infoContainer,
} from "../../utils/functions";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

export class ManualProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      provider: this.getDefaulttProvider(props),
      modal: {
        show: false,
        type: "loading",
        modalMessage: { title: "", message: "" },
      },
      errors: {},
      institution: {
        ...(!this.props.bscForm && {
          lineCreditCurrencyList: this.props.currencies,
        }),
      },
      readOnly: false,
      token: { show: false, code: null },
      currentURL: window.location.pathname,
      updateRequestData: {},
      submittedCsa: false,
    };
  }

  getDefaulttProvider = (props) => {
    var providerData = {};

    if (props.client !== undefined && props.client.cif !== undefined) {
      providerData = {
        ...props.client,
        businessId: props.client.identification,
      };
    } else if (props.provider !== undefined) {
      providerData = props.provider;
    }

    return {
      idProvider:
        undefined !== providerData.provider && null !== providerData.provider
          ? providerData.provider.id
          : "",
      id:
        undefined !== providerData.id && null !== providerData.id
          ? providerData.id
          : "",
      identification:
        undefined !== providerData.businessIdType &&
        null !== providerData.businessIdType
          ? providerData.businessIdType
          : "",
      companyName:
        undefined !== providerData.name && null !== providerData.name
          ? providerData.name
          : "",
      phone:
        undefined !== providerData.provider &&
        undefined !== providerData.provider.phoneProvider &&
        null !== providerData.provider.phoneProvider
          ? providerData.provider.phoneProvider
          : "",
      companyId:
        undefined !== providerData.businessId &&
        null !== providerData.businessId
          ? providerData.businessId
          : "",
      bankAccount:
        undefined !== providerData.provider && null !== providerData.provider
          ? undefined !== providerData.provider.accounts[0].accountNumber
            ? providerData.provider.accounts[0].accountNumber
            : ""
          : "",
      contactName:
        undefined !== providerData.provider &&
        undefined !== providerData.provider.notificationNameProvider &&
        null !== providerData.provider.notificationNameProvider
          ? providerData.provider.notificationNameProvider
          : "",
      payMethod:
        undefined !== providerData.provider && null !== providerData.provider
          ? undefined !== providerData.provider.accounts[0].accountType
            ? providerData.provider.accounts[0].accountType
            : ""
          : "",
      currency:
        undefined !== providerData.provider
          ? undefined !== providerData.provider.accounts[0].accountCurrency
            ? providerData.provider.accounts[0].accountCurrency
            : ""
          : "",
      contactEmail:
        undefined !== providerData.provider &&
        undefined !== providerData.provider.notificationEmailProvider &&
        null !== providerData.provider.notificationEmailProvider
          ? providerData.provider.notificationEmailProvider
          : "",
      accountIntermediaryBank:
        undefined !== providerData.provider
          ? undefined !==
            providerData.provider.accounts[0].accountIntermediaryBank
            ? providerData.provider.accounts[0].accountIntermediaryBank
            : ""
          : "",
      bicDestinationBank:
        undefined !== providerData.provider
          ? undefined !== providerData.provider.accounts[0].bicDestinationBank
            ? providerData.provider.accounts[0].bicDestinationBank
            : ""
          : "",
      bicIntermediaryBank:
        undefined !== providerData.provider
          ? undefined !== providerData.provider.accounts[0].bicIntermediaryBank
            ? providerData.provider.accounts[0].bicIntermediaryBank
            : ""
          : "",
      countryId:
        null !== providerData.address && undefined !== providerData.address
          ? undefined !== providerData.address.country.id
            ? providerData.address.country.id
            : 0
          : undefined !== providerData.provider
          ? undefined !== providerData.provider.country.id
            ? providerData.provider.country.id
            : 0
          : 0,
      countryName:
        null !== providerData.address && undefined !== providerData.address
          ? undefined !== providerData.address.country.name &&
            null !== providerData.address.country.name
            ? providerData.address.country.name
            : ""
          : undefined !== providerData.provider
          ? undefined !== providerData.provider.country.name
            ? providerData.provider.country.name
            : ""
          : "",
      city:
        null !== providerData.address && undefined !== providerData.address
          ? null !== providerData.address.city
            ? providerData.address.city
            : ""
          : undefined !== providerData.provider
          ? undefined !== providerData.provider.residenceCity &&
            null !== providerData.provider.residenceCity
            ? providerData.provider.residenceCity
            : ""
          : "",
      address:
        null !== providerData.address && undefined !== providerData.address
          ? null !== providerData.address.addressLineOne
            ? providerData.address.addressLineOne
            : ""
          : undefined !== providerData.provider
          ? undefined !== providerData.provider.address &&
            null !== providerData.provider.address
            ? providerData.provider.address
            : ""
          : "",
      legalSignerWrappers: [],
    };
  };

  componentDidMount() {
    const {
      bySearch,
      actions: { getClientAccounts, getACHBanks },
      client,
      session,
    } = this.props;

    /* istanbul ignore else */
    if (true === bySearch && null !== client.address) {
      const { modal } = this.state;
      modal.show = true;

      this.setState({ modal });
      return getClientAccounts(client.cif, client.address.country.code).then(
        () => {
          modal.show = false;
          this.setState({ modal });
        }
      );
    } else if (session.userType === "CSA" && session.countryCode === "PA") {
      return getACHBanks(session.countryCode);
    }

    return false;
  }

  componentDidUpdate(prevProps) {
    const { client, bySearch } = this.props;

    /* istanbul ignore else */
    if (
      prevProps.bySearch !== bySearch ||
      prevProps.client.identification !== client.identification
    ) {
      /* istanbul ignore else */
      if (
        bySearch === true &&
        client.identification !== this.state.provider.companyId
      ) {
        this.setState({ provider: this.getDefaulttProvider(this.props) });
      } else if (false === bySearch && undefined !== client.identification) {
        this.props.actions.clearClientByCif();
        this.setState({ provider: this.getDefaulttProvider({}) });
      }
    }
  }

  componentWillUnmount() {
    this.props.actions.clearClientByCif();
    this.props.actions.clearClientAccounts();
  }

  closeModal() {
    const { modal } = this.state;
    modal.show = false;
    modal.type = "loading";
    modal.modalMessage = { title: "", message: "" };
    this.setState({ modal });
  }

  clearState = () => {
    var { provider, institution, token } = this.state;
    provider.companyName = "";
    provider.phone = "";
    {
      this.state.currentURL === `/providers/${provider.idProvider}/profile`
        ? false
        : (provider.companyId = "");
    }
    provider.bankAccount = "";
    provider.contactName = "";
    provider.payMethod = "";
    provider.contactEmail = "";
    provider.countryId = 0;
    provider.city = "";
    provider.address = "";
    provider.accountIntermediaryBank = "";
    provider.bicDestinationBank = "";
    provider.bicIntermediaryBank = "";
    provider.currency = "";
    provider.identification = "";
    provider.countryName = "";
    provider.legalSignerWrappers = [];
    token.show = false;
    token.code = null;

    /* istanbul ignore else */
    if (true === this.props.bscForm) {
      institution = {};
    }

    this.setState({ provider, institution, token });
  };

  getProviderData(provider) {
    let object = {
      id: provider.id,
      businessId: provider.companyId,
      name: provider.companyName,
      companyName: provider.companyName,
      countryId: provider.countryId,
      businessIdType: provider.identification,
      notificationProvider: {
        notificationEmail: provider.contactEmail,
        notificationName: provider.contactName,
        phone: provider.phone,
      },
      provider: {
        accounts: [
          {
            accountCurrency: provider.currency,
            accountIntermediaryBank:
              provider.accountIntermediaryBank != ""
                ? provider.accountIntermediaryBank
                : null,
            accountNumber:
              provider.bankAccount != "" ? provider.bankAccount : null,
            accountType: provider.payMethod,
            bicDestinationBank:
              provider.bicDestinationBank != ""
                ? provider.bicDestinationBank
                : null,
            bicIntermediaryBank:
              provider.bicIntermediaryBank != ""
                ? provider.bicIntermediaryBank
                : null,
            iban: true,
          },
        ],
        address: provider.address,
        residenceCity: provider.city,
      },
    };

    /* istanbul ignore else */
    if (this.props.bscForm === true) {
      object.provider.legalSignerRequests = provider.legalSignerWrappers.filter(
        (signer) => signer !== null
      );
    }

    return object;
  }

  saveProvider = ({ providerInfo = undefined, validToken = null }) => {
    if (providerInfo !== undefined) {
      this.setState({ provider: providerInfo });
    }

    if (this.props.needToken && validToken === null) {
      // Vamos a solicitar el token
      const { token } = this.state;
      this.setState({ token: { ...token, show: true }, readOnly: true });
    } else {
      const { modal } = this.state;
      const {
        instance: { instanceAction },
        t,
      } = this.props;
      modal.show = true;
      this.setState({ modal });

      var submitUrl =
        true === this.props.bscForm
          ? `${this.props.submitUrl}/${this.state.institution.company.id}`
          : `${this.props.submitUrl}/${this.state.provider.idProvider}`;

      var providerObj =
        providerInfo !== undefined ? providerInfo : this.state.provider;
      const providerData = this.getProviderData(providerObj);

      var apiHeader =
        validToken !== null ? { "x-security-code": validToken } : {};

      return instanceAction(
        submitUrl,
        this.props.submitMethod,
        providerData,
        apiHeader
      )
        .then((res) => {
          const previusDeleted =
            res.data?.data.quantityBills &&
            res.data?.data.companyProviderWasDeleted;

          //desea traer las facturas que tenía antes de la eliminación o no mostrarlas
          //titles
          const title = previusDeleted ? "titleBills" : "successTitle";
          const description = previusDeleted
            ? "descriptionBills"
            : "successDescription";

          modal.type = previusDeleted ? "previusDeleted" : "success";
          modal.modalMessage = {
            title: t(`providers.manual.${title}`),
            message: t(`providers.manual.${description}`),
          };

          this.setState({
            modal,
            updateRequestData: previusDeleted
              ? {
                  providerId: res.data?.data.provider.id,
                  companyId: this.props.session.clientId,
                }
              : null,
            submittedCsa: !!this.state.provider?.idProvider,
          });
          // Limpiamos el objeto para volver a llenar la data o lo mandamos a la lista de proveedores???
          this.clearState();
        })
        .catch((err) => {
          /* istanbul ignore else */
          if (
            err.response !== undefined &&
            Array.isArray(err.response.data.notifications)
          ) {
            const notification = err.response.data.notifications[0];
            modal.modalMessage = {
              title: notification.message || "Error",
              message: notification.description,
            };
          }
          modal.type = "error";
          this.setState({
            modal,
            token: { show: false, code: null },
            readOnly: false,
          });
        });
    }
  };

  handlePreviusBills = async (hide) => {
    const { t } = this.props;
    const ref = "providers.manual.modalSuccessHideBills.";
    try {
      this.setState({ modal: { show: true, type: "loading" } });
      await this.props.instance.instanceAction(
        "/bills/hide-bills-company-provider",
        "post",
        [
          {
            ...this.state.updateRequestData,
            hide,
          },
        ]
      );

      const modal = {
        show: !hide,
        type: !hide ? "success" : null,
        modalMessage: {
          title: t(`${ref}title`),
          message: t(`${ref}description`),
        },
      };

      this.setState({ modal, updateRequestData: null });
    } catch (err) {
      this.setState({
        modal: {
          show: true,
          type: "error",
          modalMessage: {
            title: "Error",
            message: err.response?.data?.notifications[0],
          },
        },
      });
    }
  };

  getModalContent = () => {
    const { type, modalMessage } = this.state.modal;
    const { submittedCsa } = this.state;
    const { t } = this.props;

    const action =
      type === "success" && submittedCsa
        ? () => this.props.history.push("/providers")
        : () => this.closeModal();

    const loadingTitle = this.state.provider?.idProvider
      ? "editing"
      : "modalloading";

    switch (type) {
      case "loading":
        return loadingHtml(`${t(`providers.manual.${loadingTitle}`)}`);
      case "success":
        return sucessInfoModal(modalMessage.title, modalMessage.message, {
          SelBtn: { action, text: t("general.buttons.accept") },
        });
      case "error":
        return errorContainer(modalMessage.title, modalMessage.message, {
          continueBtn: { action, text: t("general.buttons.continue") },
        });
      case "previusDeleted":
        return infoContainer(modalMessage.title, modalMessage.message, {
          SelBtn: {
            text: t("providers.manual.previusDeleteButtons.yes"),
            action: () => this.handlePreviusBills(false),
          },
          formBtn: {
            text: t("providers.manual.previusDeleteButtons.no"),
            action: () => this.handlePreviusBills(true),
          },
        });
      case "getInstitution":
        return <FindInstitution selectedClient={this.selectedClient} />;
    }
  };

  selectedClient = (item) => {
    this.setState({ institution: item });
    this.closeModal();
    this.loadACHAccounts(item);
  };

  searchInstitutions = () => {
    const { modal, errors } = this.state;
    modal.show = true;
    modal.type = "getInstitution";
    delete errors["institution"];
    this.setState({ modal, errors });
  };

  deleteInstitution = () => {
    const { errors } = this.state;
    delete errors["institution"];
    this.setState({ institution: {}, errors });
  };

  loadACHAccounts = (item) => {
    const { actions } = this.props;
    /* istanbul ignore else */
    if (item.country !== undefined && item.country.code == "PA") {
      return actions.getACHBanks(item.country.code);
    }
  };

  render() {
    const { provider, institution, readOnly } = this.state;
    const { t, country, bscForm, achbanks } = this.props;

    var currentCountry =
      bscForm === true
        ? institution.country !== undefined
          ? institution.country.code
          : ""
        : country;

    return (
      <div className="manualMain">
        <div className="actions-title">
          {institution.country !== undefined ? (
            <img
              src={`data:image/png;base64,${institution.country.flag}`}
              className="icon"
            />
          ) : (
            <img src={personProvider} className="icon" />
          )}
          <p>{t("providers.manual.title")}</p>
        </div>
        <FormTemplate
          readOnly={readOnly}
          providerOj={provider}
          institution={institution}
          country={currentCountry}
          clearState={this.clearState}
          bscForm={bscForm}
          achbanks={achbanks}
          bySearch={this.props.bySearch}
          accounts={this.props.accounts}
          needToken={this.props.needToken}
          saveProvider={this.saveProvider}
          showToken={this.state.token.show}
          currentURL={this.state.currentURL}
          deleteInstitution={this.deleteInstitution}
          searchInstitutions={this.searchInstitutions}
        />
        {this.props.needToken && this.state.token.show && (
          <TokenComponent
            send={this.saveProvider}
            goBack={() =>
              this.setState({
                token: { show: false, code: null },
                readOnly: false,
              })
            }
          />
        )}
        <Modal
          key={`provider-manual`}
          show={this.state.modal.show}
          handleClose={
            this.state.modal.type == "loading"
              ? undefined
              : () => this.closeModal()
          }
        >
          {this.getModalContent()}
        </Modal>
      </div>
    );
  }
}

ManualProvider.defaultProps = {
  submitUrl: "/providers/me",
  bscForm: false,
  submitMethod: "post",
  needToken: false,
};

export const mapStateToProps = (state) => {
  return {
    client: getClient(state),
    accounts: getAccounts(state),
    country: getSessionCountry(state),
    achbanks: getAchBanks(state),
    session: getSessionInfo(state),
    currencies: [
      ...new Set(
        state.creditLineReducer?.currencies?.map(
          ({ currencyCode }) => currencyCode
        )
      ),
    ],  };
};

export const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(
      { ...ClientActions, ...ProviderActions },
      dispatch
    ),
    instance: bindActionCreators(instanceActions, dispatch),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatch)(withTranslation()(ManualProvider))
);
